// --ng Modules--
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { MatExpansionModule, MatInputModule, MatRadioModule, MatSliderModule, MatTabsModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BusyModule } from 'angular2-busy';
import { ModalModule } from 'angular2-modal';
import { BootstrapModalModule } from 'angular2-modal/plugins/bootstrap';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { VirtualScrollModule } from 'angular2-virtual-scroll';
import 'hammerjs';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { FancyImageUploaderModule } from 'ng2-fancy-image-uploader';
import { Ng2MapModule } from 'ng2-map';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
// import { SelectModule } from 'ng2-select';
import { TranslateModule } from 'ng2-translate';
import { TranslateLoader, TranslateService } from 'ng2-translate/ng2-translate';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
// External Component
import { AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { AgentLocatorAgentdetailComponent } from './agentlocator/agent-locator-agentdetail/agent-locator-agentdetail.component';
import { StoreLocatorStoredetailComponent } from './mywallet/store/store-locator-storedetail/store-locator-storedetail.component';
import { AgentLocatorComponent } from './agentLocator/agentlocator.component';
// --components--
import { AppComponent } from './app.component';
import { routes } from './app.route';
import { DashboardExchangerateComponent } from './dash-board/dashboard-exchangerate/dashboard-exchangerate.component';
import { DashBoardComponent } from './dash-board/dashboard-landingpage/dash-board.component';
import { DashboardQuickresendComponent } from './dash-board/dashboard-quickresend/dashboard-quickresend.component';
import { DashboardSupersendComponent } from './dash-board/dashboard-supersend/dashboard-supersend.component';
import { MessagecentercontainerComponent } from './dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component';
import { PaymentReceiptContainerDebitcardComponent } from './dash-board/paymernt-receipt-container/payment-receipt-container-debitcard/payment-receipt-container-debitcard.component';
import { PaymentReceiptContainerStoreComponent } from './dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component';
import { SharepromotionalcodecontainerComponent } from './dash-board/sharepromotionalcodecontainer/sharepromotionalcodecontainer.component';
import { PaymentReceiptDebitcardComponent } from './dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-detail/payment-receipt-debitcard.component';
import { PaymentReceiptDebitcardindividualPopupComponent } from './dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-individual-popup/payment-receipt-debitcard-individual-popup.component';
import { PaymentReceiptDebitcardindividualComponent } from './dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-individual/payment-receipt-debitcard-individual.component';
import { PaymentReceiptStoreComponent } from './dash-board/shoppingcart/payment-receipt-store/payment-receipt-store.component';
import { ShoppingcartlistComponent } from './dash-board/shoppingcart/shoppingcartlist/shoppingcartlist.component';
import { ShoppingcartsummaryComponent } from './dash-board/shoppingcart/shoppingcartsummary/shoppingcartsummary.component';
// Exchange rate
import { ExchangeRateComponent } from './exchange-rate/exchange-rate.component';
// Pipe
import { AddcardComponent } from './mywallet/card/addcard/addcard.component';
import { CardlistComponent } from './mywallet/card/cardlist/cardlist.component';
import { DeletestoreComponent } from './mywallet/store/deletestore/deletestore.component';
import { StorelistComponent } from './mywallet/store/storelist/storelist.component';
import { StoremapComponent } from './mywallet/store/storemap/storemap.component';
import { WalletloyaltycardComponent } from './mywallet/walletloyaltycard/walletloyaltycard.component';
import { WalletoptionComponent } from './mywallet/walletoption/walletoption.component';
import { RepeatorderDashboardlistComponent } from './repeatorder/repeatorderlist-dashboard/repeatorderlist-dashBoard.component';
import { RepeatorderlistComponent } from './repeatorder/repeatorderlist/repeatorderlist.component';
import { AgentDetailsComponent } from './sendMoney/agent-details/agent-details.component';
import { BeneficiaryComponent } from './sendMoney/beneficiary/beneficiary.component';
import { DebitcardComponent } from './sendMoney/debitcard/debitcard.component';
import { PaymentReceiptComponent } from './sendMoney/payment-receipt/payment-receipt.component';
import { PaymentTypeComponent } from './sendMoney/payment-type/payment-type.component';
import { PickupCenterComponent } from './sendMoney/pickup-center/pickup-center.component';
import { PickupTypeComponent } from './sendMoney/pickup-type/pickup-type.component';
import { SendmoneyComponent } from './sendMoney/sendmoney.component';
import { StoreDetailsComponent } from './sendMoney/store-details/store-details.component';
import { SummaryComponent } from './sendMoney/summary/summary.component';
import { AddAccountDetailComponent } from './sendMoney/_add-account-detail/add-account-detail.component';
import { AddEditBeneficiaryComponent } from './sendMoney/_add-edit-beneficiary/add-edit-beneficiary.component';
import { BranchDetailsComponent } from './sendMoney/_branch-details/_branch-details.component';
import { BranchComponent } from './sendMoney/_branch/branch.component';
import { AdditionalInfoPopupComponent } from 'app/sendmoney/_modalpopup/additional-info-popup/additional-info-popup.component';
import { AgentDetailModalComponent } from './sendMoney/_modalpopup/agent-popup/agent-popup.component';
import { storedetailmodalcomponent } from './sendMoney/_modalpopup/store-popup/store-popup.component';
import { SummarydetailPopupComponent } from './sendMoney/_modalpopup/summarydetail-popup/summarydetail-popup.component';
import { PayatstoreComponent } from './sendMoney/_payatstore/payatstore.component';
import { SummaryDetailComponent } from './sendMoney/_summary-detail/summary-detail.component';
import { AboutUsComponent } from './sharedcomponents/about-us/about-us.component';
import { geolocation } from './sharedcomponents/commonservice/geolocation/geoloc';
import { GoogleAnalyticsEventsService } from './sharedcomponents/commonservice/googleAnalytics/google-analytics-events-service.service';
import { SpanishCharConverstion } from './sharedcomponents/commonservice/SpanishTextHandling.service';
import { utilityService } from './sharedcomponents/commonservice/utility.service';
import { sharedModule } from './sharedcomponents/shared-routing.module';
import { SharepromotainalPopupComponent } from './sharedcomponents/sharepromotionalcode/sharepromotainal-popup/sharepromotainal-popup.component';
import { TutorialComponent } from './sharedcomponents/tutorial/tutorial.component';
import { AppSettings } from './sharedcomponents/_common/constants/app.constants';
import { DeactivateGuardService } from './sharedcomponents/_common/deactivate-guard.service';
import { DoNotRefreshAndBackComponent } from './sharedcomponents/_directive/do-not-refresh-and-back/do-not-refresh-and-back.component';
import { transactionhistoryModule } from './transaction-history/transaction-routing.module';
import { CustomLoader } from './Translate/customtranslate';
import { LoginComponent } from './user//login/login.component';
import { ForgetPasswordComponent } from './user/forget-password/forget-password.component';
import { LoyaltyLoginComponent } from './user/loyalty-login/loyalty-login.component-Step1';
import { loyaltyCardverificationComponent } from './user/loyalty-login/loyalty-login.component-Step2';
import { loyaltyOTPverificationComponent } from './user/loyalty-login/loyalty-login.component-Step3';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { ResetPasswordEditProfileComponent } from './user/reset-password/reset-password.EditProfile.component';
import { LinkUserComponent } from './user/user-register/RegistrationPopup/link-user/link-user.component';
import { UserInfoComponent } from './user/user-register/RegistrationPopup/user-info/user-info.component';
import { VerifyMobileComponent } from './user/user-register/RegistrationPopup/verify-mobile/verify-mobile.component';
import { uploaddocumtuserprofilestep1 } from './user/user-register/user-document-upload/userprofile-document-upload.component-Step1';
import { uploaddocumtuserprofilestep2 } from './user/user-register/user-document-upload/userprofile-document-upload.component-Step2';
import { EditProfileMobileOTPComponent } from './user/user-register/user-editprofile-mobileOTPVerification/user-editProfileMobileOTPVerification';
import { UserEditProfileComponent } from './user/user-register/user-editprofile.component';
import { UserRegisterComponent } from './user/user-register/user-register.component';
import { VerifyDeviceComponent } from './user/verify-device/verify-device.component';
import { AgentStoreDetail } from './_services/agentlocator/agentlocatorservice';
// Cart
import { CartServiceService } from './_services/dashboardservice/cart/cart-service.service';
import { mywalletstore } from './_services/mywallet/store/mywallet.store.service';
import { PaymentreceiptService } from './_services/paymentreceipt/paymentreceipt.service';
import { RepeatorderService } from './_services/repeatorder/repeatorder.service';
import { SendMoneyService } from './_services/sendmoneyservice/sendmoneyservice';
import { PayagainFailedorderService } from './_services/transaction/payagain-failedorder.service';
import { TransactionHistoryService } from './_services/transaction/transaction-history.service';
import { usercommonattribute } from './_services/userservice/user.common.service';
import { userGioLocationService } from './_services/UserService/user.giolocation.service';
import { loyaltylogin } from './_services/userservice/user.loyaltylogin.service';
import { UserStateService } from './_services/userservice/userstateservice';

const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashBoardComponent,
    UserRegisterComponent,
    UserEditProfileComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    ResetPasswordEditProfileComponent,
    VerifyMobileComponent,
    UserInfoComponent,
    LinkUserComponent,
    LoyaltyLoginComponent,
    loyaltyCardverificationComponent,
    loyaltyOTPverificationComponent,
    PickupTypeComponent,
    PickupCenterComponent,
    BeneficiaryComponent,
    PaymentTypeComponent,
    SummaryComponent,
    SendmoneyComponent,
    AgentDetailModalComponent,
    storedetailmodalcomponent,
    BranchComponent,
    BranchDetailsComponent,
    AgentDetailsComponent,
    uploaddocumtuserprofilestep1,
    uploaddocumtuserprofilestep2,
    SummaryDetailComponent,
    AddEditBeneficiaryComponent,
    AdditionalInfoPopupComponent,
    AddcardComponent,
    WalletoptionComponent,
    StorelistComponent,
    WalletloyaltycardComponent,
    WalletloyaltycardComponent,
    PayatstoreComponent,
    DashboardQuickresendComponent,
    DashboardSupersendComponent,
    DashboardExchangerateComponent,
    ShoppingcartlistComponent,
    ShoppingcartsummaryComponent,
    StoreDetailsComponent,
    DebitcardComponent,
    ExchangeRateComponent,
    RepeatorderDashboardlistComponent,
    AddAccountDetailComponent,
    StoremapComponent,
    PaymentReceiptDebitcardComponent,
    PaymentReceiptDebitcardindividualComponent,
    PaymentReceiptDebitcardindividualPopupComponent,
    PaymentReceiptContainerDebitcardComponent,
    PaymentReceiptContainerStoreComponent,
    PaymentReceiptStoreComponent,
    SharepromotionalcodecontainerComponent,
    MessagecentercontainerComponent,
    AgentLocatorComponent,
    AgentLocatorAgentdetailComponent,
    StoreLocatorStoredetailComponent,
    PaymentReceiptComponent,
    AboutUsComponent,
    VerifyDeviceComponent,
    TutorialComponent,
    EditProfileMobileOTPComponent,
    BranchDetailsComponent,
    RepeatorderlistComponent,
    SummarydetailPopupComponent,
    SharepromotainalPopupComponent,
    DoNotRefreshAndBackComponent,
    DeletestoreComponent
  ],
  imports: [
    PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG),
    BrowserModule,
    FormsModule,
    HttpModule,
    // SelectModule,
    routes,
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useClass: CustomLoader,
      deps: [Http]
    }),
    ModalModule.forRoot(),
    BootstrapModalModule,
    CalendarModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatExpansionModule,
    MatRadioModule,
    MatSliderModule,
    MatInputModule,
    sharedModule,
    transactionhistoryModule,
    BusyModule,
    Ng2DeviceDetectorModule.forRoot(),
    Ng2MapModule.forRoot({ apiUrl: AppSettings.mapurl }),
    Ng4GeoautocompleteModule.forRoot(),
    AutoCompleteModule,
    VirtualScrollModule,
    HttpClientModule,
    FancyImageUploaderModule,
    NgIdleKeepaliveModule.forRoot()
  ],

  providers: [
    utilityService,
    GoogleAnalyticsEventsService,
    TranslateService,
    loyaltylogin,
    usercommonattribute,
    SendMoneyService,
    geolocation,
    CartServiceService,
    userGioLocationService,
    TransactionHistoryService,
    UserStateService,
    RepeatorderService,
    PayagainFailedorderService,
    mywalletstore,
    PaymentreceiptService,
    HttpClientModule,
    HttpClient,
    AgentStoreDetail,
    SpanishCharConverstion,
    DeactivateGuardService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ForgetPasswordComponent,
    ResetPasswordComponent,
    ResetPasswordEditProfileComponent,
    LoyaltyLoginComponent,
    loyaltyCardverificationComponent,
    loyaltyOTPverificationComponent,
    VerifyMobileComponent,
    UserInfoComponent,
    LinkUserComponent,
    uploaddocumtuserprofilestep1,
    uploaddocumtuserprofilestep2,
    PickupTypeComponent,
    PickupCenterComponent,
    BeneficiaryComponent,
    PaymentTypeComponent,
    SummaryComponent,
    AgentDetailModalComponent,
    storedetailmodalcomponent,
    WalletoptionComponent,
    CardlistComponent,
    AddcardComponent,
    AddEditBeneficiaryComponent,
    AdditionalInfoPopupComponent,
    ShoppingcartsummaryComponent,
    DashboardSupersendComponent,
    AboutUsComponent,
    VerifyDeviceComponent,
    TutorialComponent,
    EditProfileMobileOTPComponent,
    SummarydetailPopupComponent,
    SharepromotainalPopupComponent,
    DoNotRefreshAndBackComponent,
    DeletestoreComponent,
    PaymentReceiptDebitcardindividualPopupComponent
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts